export const SPREADSHEET_COLUMN_NAMES = {
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
} as const;

// Determines the order of the spreadsheet column names
export const SPREADSHEET_COLUMNS = [
  SPREADSHEET_COLUMN_NAMES.FIRST_NAME,
  SPREADSHEET_COLUMN_NAMES.LAST_NAME,
];

export const TEMPLATE_ROWS = [SPREADSHEET_COLUMNS, ['', '']];

type SpreadsheetRow = {
  [SPREADSHEET_COLUMN_NAMES.FIRST_NAME]: string;
  [SPREADSHEET_COLUMN_NAMES.LAST_NAME]: string;
};

export type ParsedFile = {
  headerRow: string[];
  rows: SpreadsheetRow[];
};

export type RowError = {
  row: number;
  isFirstNameMissing: boolean;
  isLastNameMissing: boolean;
  isInvalidPrefix: boolean;
};

export const ERROR_STATES = {
  DUPLICATE_IN_FILE: 'Duplicate name',
  DUPLICATE_IN_SITE: 'Duplicate name in site',
  MISSING_FIRST_NAME: 'Missing first name',
  MISSING_LAST_NAME: 'Missing last name',
  INVALID_PREFIX: 'Invalid first name',
};
